import httpClient from "./httpClient";

export const projectsApi = {
  getProjects: () => httpClient.get("/projects"),
  getProject: (id) => httpClient.get(`/projects/${id}`),
  createProject: (payload) => httpClient.post("/projects", payload),
  updateProject: (id, payload) => httpClient.put(`/projects/${id}`, payload),
  deleteProject: (id) => httpClient.delete(`/projects/${id}`),
  fetchReadme: (id, config) =>
    config
      ? httpClient.get(`/projects/${id}/readme`, config)
      : httpClient.get(`/projects/${id}/readme`),
};
